import dayjs from 'dayjs'

export const PROMOTION_START = dayjs('2022-12-17T09:08:00.000Z')
export const PROMOTION_END = dayjs('2022-12-30T00:00:00.000Z')
